import i18n from 'i18next';

const ALLOWED_KEYS = [
  "win_1", "defeat_1", "draw_1", "aborted", "pending", "in_progress",
  "team_3", "team", "solo", "bot", "AI", "Human", "one_on_one",

  "white_won_by_mat_black",
  "white_won_by_timeout_black",
  "black_won_by_timeout_white",
  "white_won_by_surrendered_black",
  "black_won_by_surrendered_white",
  "black_won_by_mat_white",
  "white_won_by_leaving_black",
  "black_won_by_leaving_white",
  "stalemate",
  "threefold_repetition",
  "insufficient_material",

  "fifty_moves",
  "resignation",
];

/**
 * Resolve input to canonical values from translation — fallback to raw input if unmatched.
 *
 * @param {string} userInput - Comma-separated search string (localized or custom)
 * @returns {Promise<string>} - Canonical English values, comma-separated
 */
export const resolveCanonicalValue = async (userInput) => {
  const currentLang = i18n.language;

  // Ensure English bundle is loaded for fallback
  if (!i18n.hasResourceBundle('en', 'translation')) {
    await i18n.loadLanguages('en');
  }

  const currentResources = i18n.getResourceBundle(currentLang, 'translation');
  const enResources = i18n.getResourceBundle('en', 'translation');

  const inputParts = userInput.split(',').map(part => part.trim()).filter(Boolean);

  const resolved = new Set();

  for (const input of inputParts) {
    let found = false;

    for (const key of ALLOWED_KEYS) {
      const localizedValue = currentResources?.[key];
      if (
        typeof localizedValue === 'string' &&
        localizedValue.toLowerCase().includes(input.toLowerCase())
      ) {
        const canonical = enResources?.[key] || key;
        resolved.add(canonical);
        found = true;
      }
    }

    if (!found) {
      resolved.add(input); // ✅ Preserve unmatched input like gameId
    }
  }

  return [...resolved].join(', ');
};
